import "./App.css";
import Main from "./page/Main";

function App() {
  return (
    <div className="App">
      <Main />
    </div>
  );
}

export default App;
